<template>
  <div>
    <div v-if="!loading">
      <div v-if="branch" class="flex flex-col">
        <div class="card mt-4">
          <p class="font-medium">#{{ branch.id }}</p>

          <div
            class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-2 text-sm mt-2"
          >
            <div>
              <p class="font-medium">Nombre</p>
              <p>{{ branch.name }}</p>
            </div>

            <div>
              <p class="font-medium">Precio default por envió</p>
              <p>
                {{ integerToCurrency(branch.local_delivery_default_price) }}
              </p>
            </div>

            <div>
              <p class="font-medium">Peso máximo por envío</p>
              <p>
                {{
                  branch.local_delivery_max_weight
                    ? branch.local_delivery_max_weight
                    : "-"
                }}
              </p>
            </div>

            <div>
              <p class="font-medium">Recoger en sucursal habilitado</p>
              <p>{{ branch.pickup_delivery ? "Sí" : "No" }}</p>
            </div>

            <div>
              <p class="font-medium">Calle</p>
              <p>{{ branch.address.street }}</p>
            </div>

            <div>
              <p class="font-medium">Número Exterior</p>
              <p>{{ branch.address.exterior_number }}</p>
            </div>

            <div>
              <p class="font-medium">Número Interior</p>
              <p>
                {{
                  branch.address.interior_number
                    ? branch.address.interior_number
                    : "-"
                }}
              </p>
            </div>

            <div>
              <p class="font-medium">Colonia</p>
              <p>
                {{
                  branch.address.neighborhood
                    ? branch.address.neighborhood
                    : "-"
                }}
              </p>
            </div>

            <div>
              <p class="font-medium">Ciudad</p>
              <p>{{ branch.address.city ? branch.address.city : "-" }}</p>
            </div>

            <div>
              <p class="font-medium">Estado</p>
              <p>{{ branch.address.state ? branch.address.state.name : "-" }}</p>
            </div>

            <div>
              <p class="font-medium">Código Postal</p>
              <p>
                {{ branch.address.zip_code ? branch.address.zip_code : "-" }}
              </p>
            </div>
          </div>

          <router-link
            v-if="hasPermission('edit_profile')"
            :to="{ name: 'branchesEditForm', params: { id: branch.id } }"
            class="secondary-button mt-4 block"
          >
            Editar
          </router-link>
        </div>
      </div>
    </div>

    <div v-else class="flex w-full h-full items-center">
      <loader-icon class="h-10 w-10 text-primary-500 mx-auto"></loader-icon>
    </div>
  </div>
</template>

<script>
import api from "@/api";
export default {
  name: "Branch Detail",

  data() {
    return {
      previousRoute: "profileDetail",
      branch: null,
      loading: false,
      loadingForm: false,
      loadingDelete: false,
    };
  },

  created() {
    this.$store.commit("setSelectedTab", "franchiseReports");

    this.loadBranch();
  },

  methods: {
    async loadBranch() {
      this.loading = true;

      try {
        this.branch = await api.branches.getById(this.$route.params.branchId);
      } catch (error) {
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.loading = false;
    },

    formatDate(datetime) {
      if (!datetime) {
        return "-";
      }

      const parts = datetime.split("-");
      const formattedDate = `${parts[1]}-${parts[2]}-${parts[0]}`;

      const date = new Date(formattedDate);

      return date.toLocaleString("en-US", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      });
    },

    integerToCurrency(amount) {
      if (amount == null) {
        return "-";
      }

      const formatter = new Intl.NumberFormat("es-MX", {
        style: "currency",
        currency: "MXN",
        minimumFractionDigits: 2,
      });

      return formatter.format(amount);
    },

    async deleteElement() {
      this.loadingDelete = true;

      try {
        const response = await api.branches.delete(this.branch.id);
        this.$store.dispatch("successSnack", response.message);
        this.closeDeleteModal();
        await this.$store.dispatch("loadUser");
      } catch (error) {
        console.log(error);
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.loadingDelete = false;
    },
  },

  watch: {
    "$route.params.branchId"() {
      this.loadBranch();
    },
  },
};
</script>